/*
  Saint Véra, busca (modal). Dono: agente G.
  <sv-search-component> dentro de <dialog-component id="search-modal"> (dialog.js do Horizon cuida de
  showModal, trava de rolagem, Esc, clique fora e retorno de foco).
  Resultados = Section Rendering API (/search/suggest?section_id=predictive-search), Liquid real.
  Abrir de fora: SV.emit('search:open') ou document.dispatchEvent(new CustomEvent('sv:search:open')).
*/
(() => {
  if (window.__svSearchInit) return;
  window.__svSearchInit = true;

  const LIMIT = 10; // teto da API /search/suggest
  const norm = (s) => String(s || '').trim();

  class SvSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const $ = (s) => this.querySelector(s);
      this.input = $('.sv-search__input');
      this.clearBtn = $('[data-sv-search-clear]');
      this.discover = $('[data-sv-discover]');
      this.results = $('[data-sv-results]');
      this.status = $('[data-sv-status]');
      this.headEl = $('[data-sv-results-title]');
      this.all = $('[data-sv-all]');
      this.allLabel = $('[data-sv-all-label]');
      this.form = $('.sv-search__form');
      this.host = this.closest('dialog-component');
      this.initialHTML = null;
      this.timer = null;
      this.ctrl = null;
      this.lastTerm = '';

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.results.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn.addEventListener('click', () => {
        this.input.value = '';
        this.onInput();
        this.input.focus({ preventScroll: true });
      });
      this.querySelectorAll('[data-sv-term]').forEach((b) =>
        b.addEventListener('click', () => {
          this.input.value = b.dataset.svTerm;
          this.onInput(true);
          this.input.focus({ preventScroll: true });
        })
      );
      this.form.addEventListener('submit', (e) => {
        if (!norm(this.input.value)) {
          e.preventDefault();
          this.input.focus({ preventScroll: true });
          this.status.textContent = 'Digite uma peça, cor ou estilo';
        }
      });
      this.querySelector('[data-sv-search-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-sv-fit]').addEventListener('click', () => {
        this.close();
        // modal do Provador é do agente C2; sem ouvinte o clique só fecha a busca
        (window.SV && SV.emit ? SV.emit('fit:open') : document.dispatchEvent(new CustomEvent('sv:fit:open')));
      });

      if (this.host) {
        this.host.addEventListener('dialog:open', () => this.onOpen());
        this.host.addEventListener('dialog:close', () => this.reset());
      }
      document.addEventListener('sv:search:open', () => this.open());
      this.setInitial();
    }

    open() {
      if (this.host && this.host.showDialog) this.host.showDialog();
    }
    close() {
      if (this.host && this.host.closeDialog) this.host.closeDialog();
    }

    onOpen() {
      this.input.focus({ preventScroll: true });
      if (this.initialHTML === null) this.loadInitial();
    }

    reset() {
      clearTimeout(this.timer);
      if (this.ctrl) this.ctrl.abort();
      this.input.value = '';
      this.lastTerm = '';
      this.setInitial();
    }

    setInitial() {
      this.clearBtn.hidden = true;
      this.discover.hidden = false;
      this.headEl.textContent = 'Peças para descobrir';
      this.status.textContent = '';
      this.results.setAttribute('aria-busy', 'false');
      this.input.setAttribute('aria-expanded', 'false');
      this.results.innerHTML = this.initialHTML || '';
      this.setAll('');
    }

    setAll(term) {
      if (term) {
        const u = new URL(this.dataset.searchUrl, location.origin);
        u.searchParams.set('q', term);
        u.searchParams.set('type', 'product');
        u.searchParams.set('options[prefix]', 'last');
        this.all.href = u.pathname + u.search;
        this.allLabel.textContent = `Ver todas as peças para “${term}”`;
      } else {
        this.all.href = this.dataset.allUrl || '/collections/all';
        this.allLabel.textContent = 'Conheça todas as peças da loja';
      }
    }

    async fetchSection(section, params = {}) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const base = params.q !== undefined ? this.dataset.suggestUrl : this.dataset.root;
      const u = new URL(base, location.origin);
      u.searchParams.set('section_id', section);
      Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
      const r = await fetch(u, { signal: this.ctrl.signal, headers: { Accept: 'text/html' } });
      if (!r.ok) throw new Error('http ' + r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const payload = doc.querySelector('.sv-search__payload');
      if (!payload) throw new Error('sem payload');
      return payload;
    }

    async loadInitial() {
      try {
        const p = await this.fetchSection('predictive-search-empty');
        this.initialHTML = p.innerHTML;
        if (!norm(this.input.value)) this.results.innerHTML = this.initialHTML;
      } catch (e) {
        if (e.name !== 'AbortError') this.initialHTML = '';
      }
    }

    onInput(now) {
      const term = norm(this.input.value);
      this.clearBtn.hidden = !this.input.value;
      clearTimeout(this.timer);
      if (!term) return this.reset2();
      if (term.length === 1) {
        if (this.ctrl) this.ctrl.abort();
        this.discover.hidden = true;
        this.headEl.textContent = 'Resultado da sua busca';
        this.results.innerHTML = '';
        this.note('Sua busca está começando.', 'Digite o nome de uma peça ou uma cor.');
        this.status.textContent = 'Digite mais uma letra';
        this.setAll('');
        return;
      }
      this.timer = setTimeout(() => this.run(term), now ? 0 : 200);
    }

    reset2() {
      if (this.ctrl) this.ctrl.abort();
      this.lastTerm = '';
      this.setInitial();
    }

    note(strong, small, retry) {
      const wrap = document.createElement('div');
      wrap.className = 'sv-search__note';
      wrap.innerHTML =
        (window.SV && SV.icon ? SV.icon('search') : '') + '<p><strong></strong><small></small></p>';
      wrap.querySelector('strong').textContent = strong;
      wrap.querySelector('small').textContent = small;
      if (retry) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv-search__retry';
        b.textContent = 'Tentar de novo';
        b.addEventListener('click', retry);
        wrap.querySelector('p').append(b);
      }
      this.results.replaceChildren(wrap);
      const svg = wrap.querySelector('svg');
      if (svg) {
        svg.setAttribute('width', 20);
        svg.setAttribute('height', 20);
      }
    }

    async run(term) {
      this.lastTerm = term;
      this.discover.hidden = true;
      this.headEl.textContent = 'Resultado da sua busca';
      this.status.textContent = 'Buscando…';
      this.results.setAttribute('aria-busy', 'true');
      this.setAll(term);
      try {
        const p = await this.fetchSection('predictive-search', {
          q: term,
          'resources[type]': 'product',
          'resources[limit]': LIMIT,
          'resources[limit_scope]': 'all',
          'resources[options][unavailable_products]': 'last',
        });
        if (term !== this.lastTerm) return;
        const n = Number(p.dataset.svCount || 0);
        this.results.setAttribute('aria-busy', 'false');
        this.input.setAttribute('aria-expanded', String(n > 0));
        if (n > 0) {
          this.results.innerHTML = p.innerHTML;
          this.status.textContent = n >= LIMIT ? `Primeiras ${n} peças` : `${n} ${n === 1 ? 'peça' : 'peças'}`;
        } else {
          this.note(
            'Vamos tentar outro caminho?',
            'Nenhuma peça corresponde à busca. Experimente uma cor ou pesquise na loja completa abaixo.'
          );
          this.status.textContent = '0 peças';
        }
        this.scrollTop = 0;
      } catch (e) {
        if (e.name === 'AbortError') return;
        this.results.setAttribute('aria-busy', 'false');
        this.status.textContent = '';
        this.note('Não conseguimos buscar agora.', 'Verifique a conexão ou pesquise na loja completa abaixo.', () =>
          this.run(term)
        );
      }
    }

    onKey(e) {
      const rows = [...this.results.querySelectorAll('[data-sv-row]')];
      if (!rows.length) return;
      const i = rows.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        rows[Math.min(i + 1, rows.length - 1)].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (i <= 0) this.input.focus();
        else rows[i - 1].focus();
      }
    }
  }

  if (!customElements.get('sv-search-component')) customElements.define('sv-search-component', SvSearch);
})();
